<template>
    <div class="flex min-w-full justify-center flex-col items-center text-center">
        <div>
            <div class="flex flex-col text-center mb-8 px-12">
                <span class="font-roundo-bold text-3xl font-bold mb-2 mt-6">Thanks, {{ forename }}</span>
                <span class="text-gray-800 text-lg sm:px-6 mt-4" v-if="progressPercentage <= 39 && this.form.showDefaultSpinnerText === true">
                    We’re working hard to match you with the best deal…
                </span>
                <span class="text-gray-800 text-lg sm:px-6 mt-4"
                    v-if="progressPercentage >= 40 && progressPercentage < 70 && this.form.showDefaultSpinnerText === true">
                    Hold tight, we’re now comparing deals to see what’s a good fit...
                </span>
                <span class="text-gray-800 text-lg sm:px-6 mt-4" v-if="progressPercentage >= 70 && this.form.showDefaultSpinnerText === true">
                    We’re nearly done, this shouldn’t take much longer...
                </span>
                <span class="text-gray-800 sm:text-xl sm:px-6 mt-4" v-if="this.form.postCompleteAction == 'mwg-signpost'">
                    After checking 30 lenders a loan wasn’t possible on this occasion – but don’t worry,<br class="xs:hidden lg:block">
                    we are passing you to our partner Money Wellness to look at alternatives
                </span>
                <span class="text-gray-800 sm:text-xl sm:px-6 mt-4" v-if="this.form.postCompleteAction == 'lender-signpost'">
                    Good news, You've been matched with a loan through {{ this.form.postCompleteLender }}.<br class="xs:hidden lg:block">
                    We'll redirect you now to complete your application.
                </span>
            </div>
            <p class="loading-text font-roundo-bold" :style="loadingTextStyle" data-text="Loading...">Loading...</p>
            <div class="flex flex-col relative items-center max-w-lg mx-auto">
                <img class="w-48" src="/img/rainbow.svg" alt="rainbow cartoon">
                <img class="absolute rotating-eye left-eye" src="/img/rainbow-eye.svg" alt="rainbow cartoon">
                <img class="absolute rotating-eye right-eye" src="/img/rainbow-eye.svg" alt="rainbow cartoon">
                <span class="text font-roundo-bold" v-html="progress"></span>
            </div>
            <div class="flex flex-col text-gray-800 text-sm px-12 text-center pt-12">
                <p v-if="this.form.showDefaultSpinnerText === true">This might take us a moment or two.</p>
                <p v-if="this.form.showDefaultSpinnerText === true">Please don’t refresh the page.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        forename: String,
        form: {},
    },
    methods: {
        startLoadingBar() {
            let timings = {
                100: 7000,
                90: 6800,
                80: 6300,
                70: 5000,
                51: 4000,
                46: 2000,
                40: 1000,
                30: 500,
                20: 200,
                0: 200
            };
            var getTiming = function (iterator) {
                for (var k in timings) {
                    if (Object.prototype.hasOwnProperty.call(timings, k)) {
                        k = parseInt(k, 10);
                        if (Object.prototype.hasOwnProperty.call(timings, k) && iterator < k) {
                            return timings[k];
                        }
                    }
                }
            };
            // Start the loop
            var i = 0;
            var timeoutLoop = () => {
                if (i >= 100) {
                    return false;
                }
                i++;
                var timing = getTiming(i);
                this.progress = (i < 10 ? '&nbsp;' : '') + i + '<small>%</small>';
                this.progressPercentage = i;
                window.progressBarTimeout = setTimeout(timeoutLoop, timing);
            };
            timeoutLoop();
        },
        calculateAnimationDuration() {
            let duration = (100 - this.progressPercentage) / 50; // Adjust this formula as needed
            return `${duration}s`;
        }
    },
    computed: {
        loadingTextStyle() {
            return {
                animationDuration: this.calculateAnimationDuration(),
            };
        }
    },
    data() {
        return {
            customer: this.customerData || {},
            progress: 1,
            progressPercentage: 1,
        };
    },
    mounted() {
        this.startLoadingBar();
    }
};
</script>

<style lang="scss" scoped>
.text {
    transition: opacity 0.25s linear;
    font-size: 13px;
    line-height: 24px;
    font-weight: bold;
    justify-self: center;
    color: theme("colors.viva-money-black");
    position: absolute;
    top: 82%;
}

.complete .text {
    visibility: hidden;
    opacity: 0;
}

.loading-text {
    color: #FDFBF3;
    text-align: center;
    font-size: 48px;
    line-height: 120.5%;
    /* 57.84px */
    letter-spacing: 0.96px;
    -webkit-text-stroke-width: 2px;
    -webkit-text-stroke-color: black;
    position: relative;
    display: inline-block;

    &:before {
        content: attr(data-text);
        position: absolute;
        overflow: hidden;
        white-space: nowrap;
        width: 0;
        color: #F0BA46;
        animation: fill-1 20s infinite;

    }
}

@keyframes fill-1 {

    0%,
    100% {
        width: 0;
    }

    99% {
        width: 100%;
    }

}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(95deg);
    }
}

.rotating-eye {
    animation: rotate 20s linear infinite;
}

.left-eye {
    right: 49%;
}

.right-eye {
    right: 43%;
}

/* Responsive adjustments */
@media (max-width: 600px) {
    .left-eye {
        right: 48%;
    }

    .right-eye {
        right: 40%;
    }
}
</style>
